// gatsby-browser.js
import React from "react";
import GlobalProvider from "./src/contexts/globalProvider";

export const wrapRootElement = ({ element }) => {
  return <GlobalProvider>{element}</GlobalProvider>;
};


export const onClientEntry = () => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v=1.0.0';
    document.head.appendChild(link);
};